(() => {
  const config = document.currentScript?.dataset;
  if (!config) return;
  const loads = new Map();
  const has = (root, selector) => root?.matches?.(selector) || !!root?.querySelector?.(selector);
  const moduleFor = (key, selector, root) => {
    if (!config[key] || loads.has(key) || !has(root, selector)) return;
    const pending = import(config[key]).catch(() => { loads.delete(key); });
    loads.set(key, pending);
  };
  const enhanceLegacy = root => {
    moduleFor('journeyUrl', 'journey-library,journey-crossroads,journey-tools,journey-path-context,journey-shop-recommendation,picture[data-journey-fallback-desktop],[data-journey-chapter]', root);
    moduleFor('interactionsUrl', '.journey-section,.journey-fool,.journey-tools,.journey-library__entry,.journey-crossroads__option,[data-lantern-demo]', root);
  };
  enhanceLegacy(document);
  document.addEventListener('shopify:section:load', event => enhanceLegacy(event.target));
  if (!config.dateUrl) return;
  const selector = 'input[data-celestial-picker],input[type="date"],input[type="time"]';
  let pending, observer;
  const loadDates = () => {
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = config.dateUrl;
      script.onload = () => { observer?.disconnect(); resolve(); };
      script.onerror = () => { script.remove(); pending = null; reject(new Error('Date enhancement unavailable')); };
      document.head.append(script);
    });
    return pending;
  };
  const proxy = {syncFromTarget(target) {
    if (!target) return;
    loadDates().then(() => {
      if (window.CelestialDatePicker !== proxy) window.CelestialDatePicker?.syncFromTarget(target);
    }).catch(() => {});
  }};
  if (!window.CelestialDatePicker) window.CelestialDatePicker = proxy;
  const scanDates = root => { if (has(root, selector)) loadDates().catch(() => {}); };
  const main = document.getElementById('MainContent');
  if (main) {
    scanDates(main);
    if ('MutationObserver' in window) {
      observer = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scanDates)));
      observer.observe(main, {childList: true, subtree: true});
    }
  }
})();
